import { render, staticRenderFns } from "./messageData.vue?vue&type=template&id=bdad2c6a&"
import script from "./messageData.vue?vue&type=script&lang=js&"
export * from "./messageData.vue?vue&type=script&lang=js&"
import style0 from "./messageData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports